import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { getAccessToken } from "../Utils/Utils.js";
import "../Utils/Utils.css";

function AddGroupToClientModal(props) {
  const [name, setName] = useState("");
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    const url =
      process.env.REACT_APP_SOPHYAPP_API_URL +
      `/de/react/${getAccessToken()}/settings/create_permission_group`;
    var params = new FormData();
    params.append("name", name);
    // params.append("client_id", props.client_id);
    axios
      .post(url, params)
      .then(function (response) {
        props.setGroup([...props.groups, response.data]);
      })
      .catch(function () {
        props.setAlertStatusDanger("danger");
      });
    props.onHide();
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {t("client.addgroupheader")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>{t("client.groupsname")}</Form.Label>
            <Form.Control
              type="text"
              placeholder="Standardgruppe"
              value={name}
              required
              autoFocus
              onChange={(e) => setName(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bs-button-color" type="submit">
            {t("mails.send")}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default AddGroupToClientModal;
